export default "__VITE_ASSET__13da2d34__"